import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, useStore } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from 'redux-state/rootSaga.js';
import { ShallowReadonly } from 'utilities/data-structures/deepReadonly.js';
import { adSlice } from './advertisement/reducer.js';
import { appSlice } from './app/reducer.js';
import { avalancheAdvisorySlice } from './avalanche-advisory/reducer.js';
import { brightcoveSlice } from './brightcove/reducer.js';
import { favouritesSlice } from './favourites/reducer.js';
import { headerWarningsSlice } from './header-warning-bar/reducer.js';
import { layoutSlice } from './layout/reducer.js';
import { loadingSlice } from './loading/reducer.js';
// import { maintenanceSlice } from './maintenance/reducer.js';
import { modulesDataUrlsSlice } from './modules-dataurl/reducer.js';
import { secondaryModulesSlice } from './modules/reducer.js';
// import { routingSlice } from './routing/reducer.js';
import { searchSlice } from './search/reducer.js';
import { warningsSlice } from './weather-warnings/reducer.js';

// const composedEnhancers = composeWithDevTools({});
const sagaMiddleware = createSagaMiddleware();

// const preload: Record<keyof IRepoState, never> = rootReducerPreloadedState;
export const store = configureStore({
  reducer: {
    ADVERTISEMENT: adSlice.reducer,
    APP: appSlice.reducer,
    AVALANCHE_ADVISORY: avalancheAdvisorySlice.reducer,
    BRIGHTCOVE: brightcoveSlice.reducer,
    FAVOURITES: favouritesSlice.reducer,
    HEADER_WARNING_BAR: headerWarningsSlice.reducer,
    LAYOUT: layoutSlice.reducer,
    LOADING: loadingSlice.reducer,
    // MAINTENANCE: maintenanceSlice.reducer,
    SECONDARY_MODULES: secondaryModulesSlice.reducer,
    MODULE_DATA_URLS: modulesDataUrlsSlice.reducer,
    // ROUTING: routingSlice.reducer,
    // ROUTINGURL: routingUrlSlice.reducer,
    SEARCH: searchSlice.reducer,
    WEATHER_WARNINGS: warningsSlice.reducer,
  },
  // preloadedState: preload,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(sagaMiddleware);
  },
});

sagaMiddleware.run(rootSaga);

// Get the type of our store variable
export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;

export type RootStateReadOnly = {
  [K in keyof RootState]: Readonly<RootState[K]>;
};
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
// So you dont have to use (state:IRepoState) => state.repo
export const useAppSelector = useSelector.withTypes<ShallowReadonly<RootState>>();

export const useAppStore = useStore.withTypes<AppStore>();

// const sagas = rootSaga;

// let sagaTask = sagaMiddleware.run(function* () {
//   yield sagas();
// });

// if (isDevEnv(false) && import.meta.webpackHot) {
//   // Load reducer changes
//   import.meta.webpackHot.accept('./rootReducer', () => {
//     import('./rootReducer.js').then((nextRootReducer) => {
//       const newRoot: Reducer<IRepoState> = nextRootReducer.rootReducer;
//       newStore.replaceReducer(newRoot);
//     });
//   });

//   // Load saga changes and restart sagas
//   // Monitor for changes to the sagas
//   import.meta.webpackHot.accept('./rootSaga', () => {
//     // Load changed sagas
//     // const getNewSagas = require('./rootSaga').default;
//     // Stop the current sagas
//     sagaTask.cancel();
//     import('./rootSaga.js').then((getNewSagas) => {
//       // When stopped, start new sagas
//       sagaTask = sagaMiddleware.run(function* replacedSaga() {
//         yield getNewSagas.rootSaga();
//       });
//     });
//   });
// }

// export const configureStoreOld = (): Store<IRepoState> => {
//   const composedEnhancers = composeWithDevTools({});
//   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//   //@ts-ignore
//   const sagaMiddleware = createSagaMiddleware();
//   const middlewares = [sagaMiddleware];
//   const middlewareEnhancer = applyMiddleware(...middlewares);
//   const store = createStore(rootReducer, {}, composedEnhancers(middlewareEnhancer));

//   const sagas = rootSaga;

//   let sagaTask = sagaMiddleware.run(function* () {
//     yield sagas();
//   });

//   if (isDevEnv(false) && import.meta.webpackHot) {
//     // Load reducer changes
//     import.meta.webpackHot.accept('./rootReducer', () => {
//       import('./rootReducer.js').then((nextRootReducer) => {
//         const updatedStore: IRepoState = nextRootReducer.rootReducer;
//         store.replaceReducer(updatedStore);
//       });
//     });

//     // Load saga changes and restart sagas
//     // Monitor for changes to the sagas
//     import.meta.webpackHot.accept('./rootSaga', () => {
//       // Load changed sagas
//       // const getNewSagas = require('./rootSaga').default;
//       // Stop the current sagas
//       sagaTask.cancel();
//       import('./rootSaga.js').then((getNewSagas) => {
//         // When stopped, start new sagas
//         sagaTask = sagaMiddleware.run(function* replacedSaga() {
//           yield getNewSagas.rootSaga();
//         });
//       });
//     });
//   }

//   return store;
// };

// export default configureStoreNew;
